<template>
<div>
<div style="margin-top: 0;" class="verticalCenter">
    <div v-for="item in $store.state.forum.messages" :key="item.id">
      <div v-show="!item.hide" :style="{'padding-left': `${item.messageTier}%`}" class="forumMessageBlock mb-4">
        <!-- <div style="bottom: 0;left: 0;position: absolute;top: 0;z-index: 2;">
          <div class="a">
            <i class="threadLine"></i>
          </div>
        </div> -->
        <div class="forumArticle">
            <div class="forumAuthor">
              <a class="underlined bold" @click.stop target="_blank" v-if="item.userPage" :href="item.userPage">{{item.authorName}}</a>
              <span v-else v-html="item.authorName"></span>
              <span v-if="item.userSpeciality">
                  (<a class="underlined bold" @click.stop target="_blank" v-if="item.userPage" :href="item.userPage">{{$t('consultationIn')}} <span v-html="item.userSpeciality[normalizeForumProp('name')]"></span></a>)
                </span>
              <span v-html="getTimeAgoFromDate(item.createdAt)"></span>
              <span v-if="item.edited">({{$t('edited')}})</span>
            </div>
            <span v-if="item.active" class="messageBox mx-3" v-html="item.message"></span>
            <p style="font-style: italic;" v-else class="messageBox mx-3">{{$t('messageDeleted')}}</p>
            <b-row v-if="!hideOptions && item.active" class="forumFooter">
                <b-col class="py-2" cols="3" sm="3" @click.stop="answerMessage(item.id)"><b-icon-chat-left class="margin-right-icon"></b-icon-chat-left><span class="hide-title-mobile">{{$t('answer')}}</span></b-col>
                <b-col class="py-2" @click.stop="messageLike(item.id)" cols="3" sm="3"><b-icon-hand-thumbs-up-fill class="opensalud-blue margin-right-icon" v-if="$store.state.forum.userBasicInfo.messagesLike.includes(item.id)"></b-icon-hand-thumbs-up-fill><b-icon-hand-thumbs-up class="margin-right-icon" v-else></b-icon-hand-thumbs-up><span class="hide-title-mobile">{{$t('like')}}</span><span v-if="item.likes"><span class="hide-title-mobile">: </span><span class="opensalud-blue">{{item.likes}}</span></span></b-col>       
                <b-col class="py-2" cols="3" sm="3" @click.stop="saveMessage(item.id)"><b-icon-bookmark-check-fill class="opensalud-blue margin-right-icon" v-if="$store.state.forum.userBasicInfo.messagesSaved.includes(item.id)"></b-icon-bookmark-check-fill><b-icon-bookmark class="margin-right-icon" v-else></b-icon-bookmark><span class="hide-title-mobile">{{$store.state.forum.userBasicInfo.messagesSaved.includes(item.id) ? $t('saved') : $t('save')}}</span></b-col>
                <b-col class="py-2" :id="`more-options-message-${item.id}`" cols="3" sm="3" @click.stop=""><b-icon-three-dots scale="1.5"></b-icon-three-dots></b-col>
            </b-row>
            <div v-if="messageIdSelected === item.id">
                <vue-editor useCustomImageHandler @image-added="handleImageAdded" v-model="wysiwygInput"></vue-editor>
                <base-button style="margin: 2% 0" @click="sendMessage(item.messageReferenceId)">{{$t('send')}}</base-button>
                <base-button style="margin: 2% 0" gray outline @click="goBack">{{$t('cancel')}}</base-button>
            </div>           
        </div>
        <b-popover :target="`more-options-message-${item.id}`" triggers="click" placement="top">
              <b-row class="more-options-row">
                <b-col cols="12" @click.stop :id="`share-socials-message-popover-${item.id}`"><div class="more-options-item"><b-icon-share class="margin-right-icon"></b-icon-share><span class="hide-title-mobile">{{$t('share')}}</span></div></b-col>
                <b-col cols="12" @click.stop="() => { wysiwygInput = item.message; messageIdSelected = item.id; editingMessage = true; $root.$emit('bv::hide::popover') }" v-if="canEditForumMessage(item.id) && item.active"><div class="more-options-item"><b-icon-pencil-square class="margin-right-icon"></b-icon-pencil-square><span class="hide-title-mobile">{{$t('edit')}}</span></div></b-col>
                <b-col cols="12" @click.stop="() => { showConfirmDelete = true; messageIdToRemove = item.id; $root.$emit('bv::hide::popover') }" v-if="canModifyForumMessage(item.id) && item.active"><div class="more-options-item"><b-icon-trash class="margin-right-icon"></b-icon-trash><span class="hide-title-mobile">{{$t('remove')}}</span></div></b-col>
                <b-col v-if="item.aspIdPublisher != $store.state.forum.userBasicInfo.userAspId" cols="12" @click.stop="() => { showReportModal = true; messageIdToReport = item.id; $root.$emit('bv::hide::popover') }"><div class="more-options-item"><b-icon-exclamation-circle class="margin-right-icon"></b-icon-exclamation-circle><span class="hide-title-mobile">{{$t('reportMessage')}}</span></div></b-col>
                <social-sharing-popover :url="shareMessageLink()" :targetId="`share-socials-message-popover-${item.id}`" :sectionName="getForumSectionTitle($store.state.forum.sectionId, true)"></social-sharing-popover>
              </b-row>
            </b-popover>
        <div style="margin-top: 2%;" v-if="showValidateMessage">
          <base-button green @click="validateMessage(item.id, true)">{{$t('validate')}}</base-button>
          <base-button red @click="validateMessage(item.id, false)">{{$t('reject')}}</base-button>
        </div>
        <div style="margin-top: 2%;" v-if="showReportMessage">
          <base-button green @click="validateReportedMessageAction(item.id, true)">{{$t('noRemove')}}</base-button>
          <base-button red @click="validateReportedMessageAction(item.id, false)">{{$t('remove')}}</base-button>
        </div>
        <div v-if="!hideOptions">
          <div class="seeMoreReplies" v-if="item.numReplies && !$store.state.forum.showMoreIds.find(i => i === item.id)">
            <b-icon class="pointer" icon="arrow-down" scale="0.7" @click="showMoreMessages(item.id)"></b-icon>
            <span class="pointer" @click="showMoreMessages(item.id)">{{$t('show')}} {{item.numReplies}} {{item.numReplies === 1 ? $t('moreReply') : $t('moreReplies')}}</span>
          </div>
          <div class="seeLessReplies" v-if="$store.state.forum.showMoreIds.find(i => i === item.id)">
            <b-icon class="pointer" icon="arrow-up" scale="0.7" @click="showLessMessages(item.id)"></b-icon>
            <span class="pointer" @click="showLessMessages(item.id)">{{$t('hideMessages')}}</span>
          </div>
        </div>
      </div>
      <social-sharing-popover :url="shareMessageLink()" :targetId="`share-socials-message-${item.id}`" :sectionName="getForumSectionTitle($store.state.forum.sectionId, true)"></social-sharing-popover>
    </div>
    <base-dialog :value="showConfirmDelete" :okFn="() => { removeMessage(); showConfirmDelete = false; }" :cancelFn="() => { showConfirmDelete = false; }" :okBtnText="$t('yes')" :cancelBtnText="$t('no')" :content="$t('removeMessageAdvice')"></base-dialog>
    <base-modal :value="showReportModal" :title="$t('reportMessageTitle')" @hidden="resetReportModal">
      <b-form-textarea :rows="10" :no-resize="true" v-model="reportReasons"></b-form-textarea>
      <div class="my-4 text-center">
        <base-button class="btn-control" @click="sendReport">{{$t('send')}}</base-button>
        <base-button class="back-btn btn-control" gray outline @click="resetReportModal">{{$t('back')}}</base-button>
      </div>
    </base-modal>
    <div v-if="!hideOptions" class="forumMessageBlock">
      <div class="seeMoreAnswers my-4" v-if="showMorePrincipalMessages">
        <b-icon class="pointer" icon="arrow-down" scale="0.7" @click="loadMorePrincipalMessages"></b-icon>
        <span class="pointer" @click="loadMorePrincipalMessages">{{$t('showMoreReplies')}}</span>
      </div>
    </div>
</div>
</div>
</template>

<script>
import { BPopover, BFormTextarea } from 'bootstrap-vue'
import forumMixin from '@/mixins/forum.mixin'
import { VueEditor } from 'vue2-editor'
import SocialSharingPopover from '@/components/base/ui/SocialSharingPopover'
import BaseDialog from '@/components/base/BaseDialog'
import BaseModal from '@/components/base/BaseModal'

export default {
  name: 'forum-message-block',
  components: {
    'base-button': () => import('@/components/base/buttons/BaseButton').then(m => m.default),
    VueEditor,
    SocialSharingPopover,
    BaseDialog,
    BPopover,
    BaseModal,
    BFormTextarea
  },
  mixins: [forumMixin],
  props: {
    entryReferenceId: String,
    numPrincipalReplies: Number,
    hideOptions: Boolean,
    showValidateMessage: Boolean,
    showReportMessage: Boolean
  },
  data () {
    return {
      messageIdSelected: null,
      editingMessage: false,
      wysiwygInput: null,
      showConfirmDelete: false,
      showReportModal: false,
      messageIdToRemove: null,
      messageIdToReport: null,
      reportReasons: null
    }
  },
  created () {
  },
  computed: {
    showMorePrincipalMessages () {
      return this.numPrincipalReplies > this.$store.state.forum.messages.filter(item => item.messageReferenceId == null).length
    }
  },
  methods: {
    answerMessage (id) {
      this.wysiwygInput = null
      this.messageIdSelected = id
    },
    resetReportModal () {
      this.reportReasons = null
      this.showReportModal = false
    },
    saveMessage (id) {
      let save = !this.$store.state.forum.userBasicInfo.messagesSaved.includes(id)
      this.$api.put('/Forum/UpdateSaveMessage', null, {params: {messageId: id, save: save}}).then((response) => {
          if (response.data) {
          if (save) {
              this.$store.state.forum.userBasicInfo.messagesSaved.push(id)
          } else {
              this.$store.state.forum.userBasicInfo.messagesSaved = this.$store.state.forum.userBasicInfo.messagesSaved.filter(item => item !== id)
          }
          this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
          } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
          }
      })
    },
    sendReport () {
      this.reportReasons = this.reportReasons ? this.reportReasons.trim() : this.reportReasons
      if (!this.reportReasons || this.reportReasons.length === 0) {
        this.$store.dispatch('showDangerAlert', this.$t('mustIntroduceReportReasons'))
        return
      }
      this.$api.post('/Forum/ReportMessage', {messageId: this.messageIdToReport, reportReasons: this.reportReasons}).then((response) => {
          if (response.data) {
            this.$store.dispatch('showSuccessAlert', this.$t('reportmessageSendConfirmation'))
            this.showReportModal = false
          } else {
            this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
          }
      })
    },
    shareMessageLink () {
      return window.location.href
    },
    sendMessage () {
      if (!this.wysiwygInput) {
        this.$store.dispatch('showDangerAlert', this.$t('emptyMessageError'))
        return
      }
      if (this.editingMessage) {
        this.$api.put('/Forum/EditEntryMessage', null, { params: { message: this.wysiwygInput, messageReferenceId: this.messageIdSelected } }).then((response) => {
          if (response.data) {
            this.messageIdSelected = null
            this.wysiwygInput = null
            this.editingMessage = false
            this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
            this.getForumMessages(this.entryReferenceId)
            this.updateLastInteractionDate(this.entryReferenceId)
          } else {
            this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
          }
        })
      } else {
        this.$api.post('/Forum/SendEntryMessage', {entryReferenceId: this.entryReferenceId, message: this.wysiwygInput, messageReferenceId: this.messageIdSelected}).then((response) => {
          if (response.data) {
            this.messageIdSelected = null
            this.wysiwygInput = null
            if (this.$store.getters['forum/forumMessageWithoutValidation']) {
              this.$store.dispatch('showSuccessAlert', this.$t('messagePublishedSuccessfully'))
              this.getForumMessages(this.entryReferenceId)
              this.updateLastInteractionDate(this.entryReferenceId)
            } else {
              this.$store.dispatch('showSuccessAlert', this.$t('messagePendingValidation'))
            }
          } else {
            this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
          }
        })
      }
    },
    showMoreMessages (id) {
      let searchItem = this.$store.state.forum.showLessIds.find(item => item === id)
      if (searchItem) {
        this.$store.state.forum.showMoreIds.push(id)
        this.toggleShowItems(id, false)
      } else {
        this.$api.get('/Forum/GetEntryMessage', {params: {entryId: this.entryReferenceId, messageReferenceId: id}}).then((response) => {
          if (response.data && response.data.entryMessageData) {
            let actualItem = this.$store.state.forum.messages.find(item => item.id === id)
            this.$store.state.forum.showMoreIds.push(id)
            let newTier = actualItem.messageTier ? actualItem.messageTier + 1 : 1
            response.data.entryMessageData.forEach(item => {
              item.messageTier = newTier
            })
            let index = this.$store.state.forum.messages.findIndex(item => item.id === id)
            this.$store.state.forum.messages.splice(index + 1, 0, ...response.data.entryMessageData)
          } else {
            this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
          }
        })
      }
    },
    showLessMessages (id) {
      // let newValues = this.$store.state.forum.showMoreIds.filter(function (item) {
      //   return item !== id
      // })
      // this.$store.state.forum.showLessIds.push(id)
      this.showLessItemByTier(id)
      // this.$store.state.forum.showMoreIds = newValues
    },
    toggleShowItems (id, hide) {
      let index = this.$store.state.forum.messages.findIndex(i => i.id === id)
      for (let i = index + 1; i < this.$store.state.forum.messages.length; i++) {
        let item = this.$store.state.forum.messages[i]
        if (item.messageReferenceId === id) {
          item.hide = hide
          this.$set(this.$store.state.forum.messages, i, item)
        } else if (!item.hide) {
          break
        }
      }
    },
    showLessItemByTier (id) {
      let index = this.$store.state.forum.messages.findIndex(i => i.id === id)
      let itemsToRemove = []
      let rootTier = this.$store.state.forum.messages[index].messageTier ? this.$store.state.forum.messages[index].messageTier : 0
      for (let i = index + 1; i < this.$store.state.forum.messages.length; i++) {
        let item = this.$store.state.forum.messages[i]
        if (item.messageTier > rootTier) {
          if (itemsToRemove.indexOf(item.messageReferenceId) === -1) {
            this.$store.state.forum.showLessIds.push(item.messageReferenceId)
            itemsToRemove.push(item.messageReferenceId)
          }
          item.hide = true
          this.$set(this.$store.state.forum.messages, i, item)
        } else {
          break
        }
      }
      this.$store.state.forum.showMoreIds = this.$store.state.forum.showMoreIds.filter(item => {
        return !itemsToRemove.includes(item)
      })
    },
    messageLike (id) {
      if (!this.$store.getters['session/isLogged']) {
        this.logIn()
        return
      }
      let like = !this.$store.state.forum.userBasicInfo.messagesLike.includes(id)
      this.$api.put('/Forum/UpdateMessageLike', null, {params: {messageId: id, like: like}}).then((response) => {
        if (response.data) {
          let item = this.$store.state.forum.messages.find(item => item.id === id)
          if (like) {
              this.$store.state.forum.userBasicInfo.messagesLike.push(id)
              item.likes = item.likes > 0 ? ++item.likes : 1
          } else {
              this.$store.state.forum.userBasicInfo.messagesLike = this.$store.state.forum.userBasicInfo.messagesLike.filter(item => item !== id)
              --item.likes
          }
          this.updateLastInteractionDate(this.entryReferenceId)
          this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
      })
    },
    loadMorePrincipalMessages () {
      let findPageNumber = this.$store.state.forum.messagesPageNumber.find(item => item.id === this.entryReferenceId)
      if (!findPageNumber) {
        this.$store.state.forum.messagesPageNumber.push({id: this.entryReferenceId, pageNumber: 1})
      } else {
        findPageNumber.pageNumber += this.$store.state.forum.messagesPerPage
      }
      this.getForumMessages(this.entryReferenceId, findPageNumber ? findPageNumber.pageNumber : 1)
    },
    removeMessage () {
      if (!this.$store.getters['session/isLogged']) {
        this.logIn()
        return
      }
      this.$api.delete('/Forum/RemoveMessage', {params: {messageId: this.messageIdToRemove}}).then((response) => {
        if (response.data) {
          this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
          this.getForumMessages(this.entryReferenceId)
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
      })
    },
    validateMessage (id, validate) {
      this.$api.post('/Forum/ValidateEntryMessage', null, {params: {messageId: id, validate: validate}}).then((response) => {
        if (response.data) {
          this.$emit('updateValidatedMessages')
          this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
      })
    },
    validateReportedMessageAction (id, validate) {
      this.$api.post('/Forum/ValidateReportedMessage', null, {params: {messageId: id, validate: validate}}).then((response) => {
        if (response.data) {
          this.$emit('updateReportedMessages')
          this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
      })
    },
    goBack () {
      this.wysiwygInput = null
      this.messageIdSelected = null
      this.editingMessage = false
    }
  }
}
</script>

<style scoped lang="scss">
    @import './static-appopensalud/css/scss/bootstrap-variables.scss';

    .a {
      box-sizing: border-box;
      cursor: pointer;
      display: inline-block;
      height: 100%;
      margin-left: 5px;
      vertical-align: top;
      width: 16px;
    }

    .threadLine {
      border-right: 2px solid #EDEFF1;
      display: block;
      height: 100%;
      width: 50%;
    }

    .forumMessageBlock {
      // background-color: #e4e4e4 !important;
      width: 60vw;
      vertical-align: baseline;
      // margin-bottom: 3%;
      @include media(mobile, tablets) {
        width: 97vw;
        /* margin-top: 8%;
        margin-bottom: 0; */
      }
    }

    .messageThread {
        padding-left: 1%;
    }

    .messageBox {
        display: block;
        font-size: initial;
        text-align: left;
        /* padding: 0% 2%;
        @include media(mobile, tablets) {
          padding: 0% 4%;
        } */
    }

    .seeMoreReplies {
      color: #e61010;
      text-align: left;
      margin-top: 10px;
      margin-left: 1%;
    }

    .seeLessReplies {
      text-align: left;
      margin-top: 10px;
      margin-left: 1%;
    }

    .seeMoreAnswers {
      color: #e61010;
      text-align: left;
      margin-top: 10px;
      margin-left: 1%;
    }
</style>


// WEBPACK FOOTER //
// src/components/views/healthy-community/forum/ForumMessageBlock.vue